export default function isTruthy(element) {
  return Boolean(element);
};